export interface ShowInactiveToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
}

export function ShowInactiveToggle({ checked, onChange }: ShowInactiveToggleProps) {
  return (
    <div className="inline-flex items-center gap-2">
      <span className="text-xs font-medium text-muted-foreground">Enrollments</span>
      <div role="radiogroup" aria-label="Enrollment status filter" className="inline-flex rounded-lg border border-border bg-muted p-0.5">
        {[{v:false,label:"Active only"},{v:true,label:"Include inactive"}].map(opt => (
          <button key={String(opt.v)} type="button" role="radio" aria-checked={checked===opt.v}
            onClick={() => onChange(opt.v)}
            className={`px-3 py-1 text-xs font-semibold rounded-md transition-colors ${checked===opt.v ? "bg-card text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`}>
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
